<template>
  <v-container pa-0 align-start :class="{'blur-content': payProcessDialog}">
    <v-app-bar app :extended="!$vuetify.breakpoint.lgAndUp" v-show="!loading">
      <v-app-bar-nav-icon @click.native="$router.replace('/dashboard')">
        <v-icon medium>close</v-icon>
      </v-app-bar-nav-icon>

      <v-toolbar-title>
        <span :class="`title  font-weight-bold`">{{ $language.jobDetails['Job Details'] }}</span>
      </v-toolbar-title>

      <!--TAB HEADERS-->

      <template v-slot:extension v-if="!$vuetify.breakpoint.lgAndUp">
        <v-tabs centered :dark="$vuetify.theme.dark" v-model="tab" grow :show-arrows="$vuetify.breakpoint.xs" :key="index">
          <v-tab href="#Summary">
            <span :class="$vuetify.breakpoint.smAndDown?'caption font-weight-bold':''">{{ $language.jobDetails['Summary'] }}</span>
          </v-tab>
          <v-tab href="#Applicants">
            <span :class="$vuetify.breakpoint.smAndDown?'caption font-weight-bold':''">{{ $language.jobDetails['Applicants'] }}</span>
          </v-tab>
          <v-tab href="#Payouts">
            <v-badge color="blue darken-1" v-if="hasPendingShifts" dot>
              <span :class="$vuetify.breakpoint.smAndDown?'caption font-weight-bold':''">{{ $language.jobDetails['Payouts'] }}</span>
            </v-badge>
            <span v-else :class="$vuetify.breakpoint.smAndDown?'caption font-weight-bold':''">{{ $language.jobDetails['Payouts'] }}</span>
          </v-tab>
        </v-tabs>
      </template>
    </v-app-bar>

    <v-container v-show="loading" fill-height align-center>
      <v-row justify="center" align="center">
        <v-col cols="12" justify="center" align="center">
          <v-progress-circular indeterminate :size="70" :width="7" color="primary"></v-progress-circular>
        </v-col>
        <h4 class="grey--text text--darken-3 mt-3">{{ $language.jobDetails['Loading Job Details'] }}</h4>
      </v-row>
    </v-container>

    <v-container pa-0 px-2 v-show="!loading">
      <div v-show="tab === 'Summary'">
        <v-container px-1>
          <v-row no-gutters v-if="$vuetify.breakpoint.lgAndUp">
            <v-col cols="4" :class="$vuetify.theme.dark?'border-dark':'border-light'">
              <job-summary :edit-job="job.public" :payouts="job.payments" @open-fav="favDrawer = true" @handle-pay-individual="handlePayIndividual($event)" :applicants="job.applicants" :has-started="hasStarted" summary-view="true" :applicant="{}" :is-hefe="isHefe" :status="(job.public||{}).status" @apply="applyDialog = true" @hire="hireDialog = true" @decline="declineDialog = true" @unpublish="unpublishDialog = true" @end-contract="endContractDialog = true" @publish="publishDialog = true" :public-view="false" @edit="editDrawer = true" @delete="deleteDialog = true" @cancel="cancelDialog = true"></job-summary>

            </v-col>
            <v-col cols="4" :class="$vuetify.theme.dark?'border-dark':'border-light'">

              <applicants-container :job="job" @open-fav="favDrawer = true" @handle-pay-individual="handlePayIndividual($event)" :applicants="job.applicants" :is-hefe="isHefe"></applicants-container>

            </v-col>
            <v-col cols="4" :class="$vuetify.theme.dark?'border-dark':'border-light'">
              <payout-container :job="job.public" :payouts="job.payments" @handle-pay-individual="handlePayIndividual($event)" :applicants="job.applicants" v-if="isHefe"></payout-container>

            </v-col>
          </v-row>
          <v-row no-gutters class="d-flex align-stretch" v-else>
            <v-col cols="12">
              <job-summary :edit-job="job.public" :payouts="job.payments" @open-fav="favDrawer = true" @handle-pay-individual="handlePayIndividual($event)" :applicants="job.applicants" :has-started="hasStarted" summary-view="true" :applicant="{}" :is-hefe="isHefe" :status="(job.public||{}).status" @apply="applyDialog = true" @hire="hireDialog = true" @decline="declineDialog = true" @unpublish="unpublishDialog = true" @end-contract="endContractDialog = true" @publish="publishDialog = true" :public-view="false" @edit="editDrawer = true" @delete="deleteDialog = true" @cancel="cancelDialog = true"></job-summary>

            </v-col>
          </v-row>

        </v-container>
      </div>
      <div v-show="tab==='Applicants'" class="py-4">
        <v-container :class="$vuetify.theme.dark?'border-dark':'border-light'">
          <applicants-container :job="job" @open-fav="favDrawer = true" @handle-pay-individual="handlePayIndividual($event)" :applicants="job.applicants" :is-hefe="isHefe"></applicants-container>

        </v-container>

      </div>
      <div v-show="tab==='Payouts'" class="py-4">
        <v-container :class="$vuetify.theme.dark?'border-dark':'border-light'">
          <payout-container :job="job.public" :payouts="job.payments" @handle-pay-individual="handlePayIndividual($event)" :applicants="job.applicants" v-if="isHefe"></payout-container>

        </v-container>
      </div>

      <!--DIALOGS-->
      <div>
        <v-dialog v-model="endContractDialog" persistent max-width="290">
          <v-card class="py-1" v-if="!hasPendingShifts">
            <v-card-title class="title py-3">{{ $language.jobDetails['End this contract?'] }}</v-card-title>
            <v-card-text>{{ $language.jobDetails['Are you sure you want to end this contract?'] }}</v-card-text>
            <v-card-actions>
              <v-row no-gutters align="center" justify="space-around" class="px-2">
                <v-col cols="5">
                  <v-btn color="primary" block text @click.native="endContractDialog = false" :disabled="buttonLoading">{{ $language.jobDetails['Cancel'] }}</v-btn>
                </v-col>
                <v-col cols="5">
                  <v-btn color="primary" block class="pr-2" depressed @click.native="endContract" :disabled="buttonLoading" :loading="buttonLoading">{{ $language.jobDetails['Confirm'] }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="profileDialog" fullscreen persistent no-click-animation transition="dialog-transition">
          <profile :userFav="userProfile.favorites" :profileRef="thisProfile" :job="job" @simple-close="thisProfile={};profileDialog = false;" @close="profileDialog = false; snackbar.show = $event.show; snackbar.message = $event.message " @confirm-hire="confirmHire($event.profileId)"></profile>
        </v-dialog>

        <!-- THIS DIALOG IS FOR SETTING A DRAFT JOB TO PUBLIC -->
        <v-dialog v-model="publishDialog" persistent max-width="290">
          <v-card class="py-1">
            <v-card-title class="title py-3">{{ $language.jobDetails['Publish this Job'] }}</v-card-title>
            <v-card-text>{{ $language.jobDetails['Do you want to allow people to apply?'] }}</v-card-text>
            <v-card-actions class="pt-2 pr-2">
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click.native="publishDialog = false">{{ $language.jobDetails['Cancel'] }}</v-btn>
              <v-btn color="primary" depressed @click.native="publishJob">{{ $language.jobDetails['Confirm'] }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- THIS DIALOG IS FOR SETTING A PUBLIC JOB TO DRAFT -->
        <v-dialog v-model="unpublishDialog" persistent max-width="290">
          <v-card class="py-1">
            <v-card-title class="title py-3">{{ $language.jobDetails['Publish this Job'] }}</v-card-title>
            <v-card-text>{{ $language.jobDetails['Do you want to allow people to apply?'] }}</v-card-text>
            <v-card-actions class="pt-2 pr-2">
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click.native="unpublishDialog = false">{{ $language.jobDetails['Cancel'] }}</v-btn>
              <v-btn color="primary" depressed @click.native="unpublishJob">{{ $language.jobDetails['Confirm'] }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- DIALOG TO DELETE JOBS-->
        <v-dialog v-model="deleteDialog" persistent max-width="290">
          <v-card class="py-1">
            <v-card-title class="title py-3">{{ $language.jobDetails['Delete this Job'] }}</v-card-title>
            <v-card-text>{{ $language.jobDetails['Are you sure you want to delete this job?'] }}</v-card-text>
            <v-card-actions>
              <v-row no-gutters align="center" justify="space-around" class="px-2">
                <v-col cols="5">
                  <v-btn color="primary" block text @click.native="deleteDialog = false" :disabled="buttonLoading">{{ $language.jobDetails['Cancel'] }}</v-btn>

                </v-col>
                <v-col cols="5">
                  <v-btn color="primary" block class="pr-2" depressed @click.native="deleteJob" :disabled="buttonLoading" :loading="buttonLoading">{{ $language.jobDetails['Confirm'] }}</v-btn>

                </v-col>
              </v-row>

            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="cancelDialog" persistent max-width="290">
          <v-card class="py-1">
            <v-card-title class="title py-3">{{ $language.jobDetails['Cancel this Job'] }}</v-card-title>
            <v-card-text>{{ $language.jobDetails['Are you sure you want to cancel this job?'] }}</v-card-text>
            <v-card-actions>
              <v-row no-gutters align="center" justify="space-around" class="px-2">
                <v-col cols="5">
                  <v-btn color="primary" block text @click.native="cancelDialog = false" :disabled="buttonLoading">{{ $language.jobDetails['Cancel'] }}</v-btn>
                </v-col>
                <v-col cols="5">
                  <v-btn color="primary" block class="pr-2" depressed @click.native="cancelJob" :disabled="buttonLoading" :loading="buttonLoading">{{ $language.jobDetails['Confirm'] }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- THIS CHANGES THE STATUS TO STARTED -->
        <v-dialog v-model="startDialog" persistent max-width="290">
          <v-card class="py-1">
            <v-card-title class="title py-3">{{ $language.jobDetails['Start this Job'] }}</v-card-title>
            <v-card-text>{{ $language.jobDetails['Do you want to start this job?'] }}</v-card-text>
            <v-card-actions class="pt-2 pr-2">
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click.native="startDialog = false" :disabled="buttonLoading">{{ $language.jobDetails['Close'] }}</v-btn>
              <v-btn color="primary" text @click.native="startJob" :disabled="buttonLoading" :loading="buttonLoading">{{ $language.jobDetails['Start Job'] }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="payProcessDialog" persistent modal max-width="400px" transition="slide-y-reverse-transition">
          <v-card dark>
            <v-card-title primary-title>
              <span class="title" v-if="(((job.payments||{}).transactions||{})[paymentId]||{}).inProcess">{{ $language.jobDetails['Processing Payment'] }}</span>
              <span class="title" v-else>{{(((job.payments||{}).transactions||{})[paymentId]||{}).status}}!</span>

            </v-card-title>
            <v-card-text>
              <v-layout column align-center justify-center>
                <v-progress-circular indeterminate :size="100" :width="7" v-if="(((job.payments||{}).transactions||{})[paymentId]||{}).inProcess">
                  <span>Processing</span>
                </v-progress-circular>

              </v-layout>
              <v-layout column align-center justify-center v-if="(((job.payments||{}).transactions||{})[paymentId]||{}).status==='Failed'">
                <span>{{$language.jobDetails['Payment Declined']}}</span>
              </v-layout>
              <v-layout column align-center justify-center v-if="(((job.payments||{}).transactions||{})[paymentId]||{}).status==='SUCCESS'">
                <span>{{$language.jobDetails['Payment Success']}}</span>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" v-if="(((job.payments||{}).transactions||{})[paymentId]||{}).status==='SUCCESS'&&!hasRating" @click="handleRateIndividual">{{ $language.jobDetails['Rate'] }}</v-btn>
              <v-btn color="primary" v-if="(((job.payments||{}).transactions||{})[paymentId]||{}).status==='SUCCESS'&&hasRating" @click="()=>{payProcessDialog = false; payDialog=false}">{{ $language.jobDetails['Close'] }}</v-btn>
              <v-btn color="primary" text v-if="(((job.payments||{}).transactions||{})[paymentId]||{}).status==='Failed'" @click="payProcessDialog = false">{{ $language.jobDetails['Close'] }}</v-btn>
              <v-btn color="primary" v-if="(((job.payments||{}).transactions||{})[paymentId]||{}).status==='Failed'" @click="openSettingsDialog">add card</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="ratingDialog" modal max-width="400px" transition="slide-y-reverse-transition">
          <v-card>
            <v-card-title primary-title>
              <span class="title">{{ $language.jobDetails['Review for'] }} {{ ((job.applicants || {})[applicantId] || {}).name || 'Worker' }}</span>

            </v-card-title>
            <v-card-text>
              <v-layout wrap justify-center>
                <v-rating size="24" large v-model="rating.rating" color="yellow darken-3" background-color="grey darken-1" empty-icon="$vuetify.icons.ratingEmpty"></v-rating>
                <v-textarea outlined label="Review" v-model="rating.comment" class="mt-2"></v-textarea>
              </v-layout>

            </v-card-text>
            <v-card-actions>
              <v-row no-gutters align="center" justify="space-around" class="px-2">
                <v-col cols="5">
                  <v-btn color="primary" text block @click.native="ratingDialog = false">{{$language.jobDetails['Cancel']}}</v-btn>

                </v-col>
                <v-col cols="5">
                  <v-btn color="primary" block @click.native="rate" :disabled="rating.rating==null">{{$language.jobDetails['Submit']}}</v-btn>
                </v-col>
              </v-row>

            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="inviteDialog" fullscreen transition="slide-y-transition" persistent>
          <InviteWorkers :job="job" :favorites="userProfile.favorites" @close="inviteDialog = false"></InviteWorkers>
        </v-dialog>

      </div>
      <v-snackbar v-model="snackbar.show" :color="snackbar.status === 'error' ? 'error' : 'success'" multi-line :timeout="1500">
        {{ snackbar.message }}
      </v-snackbar>
      <v-navigation-drawer app touchless temporary v-model="editDrawer" :stateless="dialog" persistent right enable-resize-watcher mobile-breakpoint="10240" :width="$vuetify.breakpoint.width<1024?$vuetify.breakpoint.width:$vuetify.breakpoint.width-256">
        <!-- <v-app-bar fixed flat tile>
          <v-app-bar-nav-icon>
            <v-icon medium @click="editDrawer=false">close</v-icon>
          </v-app-bar-nav-icon>
          <v-toolbar-title>
            <span class="title font-weight-bold">Edit Job Details</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-app-bar-nav-icon>
            <v-icon medium @click="save+=save">save</v-icon>
          </v-app-bar-nav-icon>
        </v-app-bar> -->
        <add-job :key="index2" @simple-close="editDrawer=false" :edit-job="this.job" :has-started="hasStarted" summary-view="true" :is-hefe="isHefe" @apply="applyDialog = true" @hire="hireDialog = true" @decline="declineDialog = true" @unpublish="unpublishDialog = true" @end-contract="endContractDialog = true" @publish="publishDialog = true" :public-view="false"></add-job>
      </v-navigation-drawer>

      <v-navigation-drawer app v-model="favDrawer" right enable-resize-watcher mobile-breakpoint="10240" :width="$vuetify.breakpoint.width>450?450:$vuetify.breakpoint.width">

        <InviteWorkers :job="job" :favorites="userProfile.favorites" @close="favDrawer = false"></InviteWorkers>

      </v-navigation-drawer>
      <v-navigation-drawer app v-model="payDrawer" right enable-resize-watcher mobile-breakpoint="10240" :width="$vuetify.breakpoint.width>450?450:$vuetify.breakpoint.width">
        <v-app-bar fixed flat tile>
          <v-app-bar-nav-icon>
            <v-icon medium @click="payDrawer=false">close</v-icon>
          </v-app-bar-nav-icon>
          <v-toolbar-title>
            <span class="title font-weight-bold">{{ $language.jobDetails['Payment to'] }} {{ ((job.applicants || {})[applicantId] || {}).name || 'Worker' }}</span>
          </v-toolbar-title>
        </v-app-bar>
        <v-container pt-16>
          <v-card :height="$vuetify.breakpoint.height-180" style="overflow-y: auto" flat tile>

            <v-list class="pt-2" :key="index3">
              <span class=" pt-4 pl-2 subheading" v-if="pendingShifts!==0&& (job.public||{}).repeat">{{$language.jobDetails['Select Shifts to Pay']}}</span>
              <template v-for="(item,index) in pendingShiftsFixed">
                <log-list-item :item="item" :index="index" :key="item._key" :is-hefe="true" v-if="(job.public||{}).rateType==='Fixed'" :pay="true" @select-shift="selectShift($event)"></log-list-item>
              </template>
              <template v-for="(item,index) in pendingShifts">
                <log-list-item :item="item" :index="index" :key="item._key" :is-hefe="true" v-if="(job.public||{}).rateType==='Hourly'" :pay="true" @select-shift="selectShift($event)"></log-list-item>
              </template>

              <!-- <template v-for="(item,index) in pendingShifts">
                  <v-list-item>
                  <log-list-item :item="item" :key="item._key" v-if="(job.public||{}).rateType==='Hourly'" @selected-shifts-fixed="selectedShifts"></log-list-item>
                    <v-list-item-avatar>
                      <v-checkbox class="pt-2" v-model="selectedShifts" :value="item"></v-checkbox>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{ item.shiftDate|formatShortDate}}</v-list-item-title>
                      <v-list-item-subtitle></v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <span class="headline" v-if="isRateTypeSelected('Hourly')">{{item.secondsWorked|formatHoursWorked}}:{{item.secondsWorked|formatMinWorked}}:{{item.secondsWorked|formatSecWorked}}</span>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider v-if="index!==pendingShifts.length-1" inset :key="index"></v-divider>
                </template> -->
            </v-list>

            <v-divider v-if="pendingShifts.length!==0"></v-divider>
            <v-list>
              <v-list-item v-if="isRateTypeSelected('Hourly')&& !(job.public||{}).repeat">
                <v-list-item-content>
                  <v-list-item-title>{{ $language.jobDetails['Hours Recorded'] }}</v-list-item-title>
                  <v-list-item-subtitle></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="text-xs-left">
                  <span>{{ ((job.applicants||{})[applicantId]||{}).secondsWorked|formatHours }}</span>
                </v-list-item-action>

              </v-list-item>
              <v-list-item v-if="isRateTypeSelected('Hourly')">
                <v-list-item-content>
                  <v-list-item-title>Job{{ $language.jobDetails[' hours'] }}</v-list-item-title>
                  <v-list-item-subtitle></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="pt-4">
                  <v-text-field class="centered-input" outlined dense type="Number" min="0" max="1000000" v-model="payment.hours" @focus="$event.target.select()"></v-text-field>
                </v-list-item-action>
              </v-list-item>

              <v-list-item v-if="isRateTypeSelected('Fixed')">
                <v-list-item-content>
                  <v-list-item-title>{{ $language.jobDetails['Amount'] }}</v-list-item-title>
                  <v-list-item-subtitle></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="pt-4">
                  <v-layout>
                    <span class="title pr-1 pt-2">$</span>
                    <v-text-field class="centered-input" outlined dense type="Number" min="0" max="1000000" v-model="payment.compensation" @focus="$event.target.select()"></v-text-field>
                  </v-layout>
                </v-list-item-action>
              </v-list-item>

              <v-divider></v-divider>

              <v-list-item>
                <v-list-item-content>
                  <v-badge color="transparent">
                    <v-icon small color="info" slot="badge">info</v-icon>
                    <v-list-item-title>{{ $language.jobDetails['Expenses'] }}</v-list-item-title>
                    <v-list-item-subtitle></v-list-item-subtitle>
                  </v-badge>
                </v-list-item-content>
                <v-list-item-action class="pt-4">
                  <v-layout>
                    <span class="title pr-1 pt-2">$</span>
                    <v-text-field class="centered-input" outlined dense type="Number" min="0" max="1000000" v-model="payment.expenses" @focus="$event.target.select()"></v-text-field>
                  </v-layout>
                </v-list-item-action>
              </v-list-item>

              <v-divider class="pb-2"></v-divider>

              <v-list-item class="pb-1">
                <v-list-item-content>
                  <v-list-item-title>{{ $language.jobDetails['Tip'] }}</v-list-item-title>
                  <v-list-item-subtitle></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="pt-4">
                  <v-layout>
                    <span class="title pr-1 pt-2">$</span>
                    <v-text-field class="centered-input" outlined dense type="Number" min="0" max="1000000" v-model="payment.tip" @focus="$event.target.select()"></v-text-field>
                  </v-layout>
                </v-list-item-action>
              </v-list-item>
              <v-list-item class="pb-2" dense>
                <v-layout>
                  <VFlex xs4 px-1>
                    <v-btn block color=" primary" @click=" payment.tip = isRateTypeSelected('Fixed') ? (payment.compensation*.05).toFixed(2) : ((payment.compensation)*.05).toFixed(2)">5%</v-btn>
                  </VFlex>
                  <VFlex xs4 px-1>
                    <v-btn block color=" primary" @click=" payment.tip = isRateTypeSelected('Fixed') ? (payment.compensation*.1).toFixed(2) : ((payment.compensation)*.1).toFixed(2)">10%</v-btn>
                  </VFlex>
                  <VFlex xs4 px-1>
                    <v-btn block color=" primary" @click=" payment.tip = isRateTypeSelected('Fixed') ? (payment.compensation*.2).toFixed(2) : ((payment.compensation)*.2).toFixed(2)">20%</v-btn>
                  </VFlex>
                </v-layout>
              </v-list-item>

              <v-divider class="py-1"></v-divider>

              <v-list-item class="pb-3">

                <v-list-item-content>
                  <v-list-item-title>{{ $language.jobDetails['Fees'] }}</v-list-item-title>
                  <v-list-item-subtitle></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="text-xs-left">
                  <span class="text-xs-left ">
                    ${{parseFloat(this.isRateTypeSelected('Fixed') ? ((parseFloat(payment.compensation) + parseFloat(payment.expenses) + parseFloat(payment.tip)) * 0.05) : (parseFloat(payment.compensation) + parseFloat(payment.expenses) + parseFloat(payment.tip)) * 0.05).toFixed(2)}}</span>
                </v-list-item-action>
              </v-list-item>

              <v-divider class="py-1 pb-2"></v-divider>

              <span class=" pt-4 pl-2 pb-16 subheading">{{$language.settings['Payment Methods']}}</span>
              <v-layout column justify-center align-center v-if="(userProfile.stripeCustomerAccount||{}).processing">
                <v-progress-circular indeterminate :size="70" :width="7" color="primary"></v-progress-circular>
              </v-layout>
              <v-list-item v-for="item in ((((userProfile||{}).stripeCustomerAccount||{}).sources||{}).data||{})" :key="item.id" v-else>
                <v-list-item-avatar>
                  <v-icon large :color="item.id === userProfile.stripeCustomerAccount.default_source?'primary':'grey'">credit_card</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title :class="`${item.id === userProfile.stripeCustomerAccount.default_source?'primary--text':'grey--text lighten-1'}`">
                    {{item.brand}} {{ $language.settings['ending'] }} ···· {{item.last4}} <span v-if="item.id === userProfile.stripeCustomerAccount.default_source" class="primary--text lighten-2">(current)</span>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="item.id !== userProfile.stripeCustomerAccount.default_source">
                  <template>
                    <div class="text-xs-center">
                      <v-menu>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">more_vert</v-icon>
                        </template>
                        <v-list>
                          <v-list-item @click="setNewDefault(item)">
                            <v-list-item-title>Use</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </template>
                </v-list-item-action>
              </v-list-item>
            </v-list>

          </v-card>

        </v-container>
        <v-app-bar bottom flat tile height="104" :fixed="$vuetify.breakpoint.lgAndUp">
          <v-container fill-height pa-0 align-start>
            <v-row>
              <v-list-item class=" pb-0 " height="40">
                <v-list-item-content class="headline font-weight-bold ">
                  <span>{{ $language.jobDetails['Total'] }}:</span>
                </v-list-item-content>
                <v-list-item-action class="text-left">
                  <span>${{parseFloat(this.isRateTypeSelected('Fixed') ? ((parseFloat(payment.compensation) + parseFloat(payment.expenses) + parseFloat(payment.tip)) * 1.05) : (parseFloat(payment.compensation) + parseFloat(payment.expenses) + parseFloat(this.payment.tip)) * 1.05).toFixed(2)}}</span>
                </v-list-item-action>
              </v-list-item>
              <v-btn block large color="primary" @click="payIndividual" :disabled="!canPay">{{ $language.jobDetails['Pay'] }}</v-btn>
            </v-row>
          </v-container>
        </v-app-bar>
      </v-navigation-drawer>
    </v-container>
  </v-container>

</template>

<script>
import {
  mapState
} from 'vuex'
import moment from 'moment'
import {
  object
} from 'rxfire/database'
import {
  map
} from 'rxjs/operators'
import Profile from '@/components/common/Profile'
import JobSummary from '@/components/common/JobSummary'
import AddJob from '@/components/common/AddJob'
import InviteWorkers from '@/components/jefe/InviteWorkers'
import ApplicantsContainer from '@/components/jefe/applicants/ApplicantsContainer'
import PayoutContainer from '@/components/jefe/payouts/PayoutContainer'
import LogListItem from '@/components/common/log/LogListItem'
const fb = require('@/services/firebaseConfig.js')

export default {
  props: ['jobRef', 'profileId', 'defaultTab'],
  components: {
    Profile,
    AddJob,
    InviteWorkers,
    JobSummary,
    ApplicantsContainer,
    PayoutContainer,
    LogListItem
  },
  data () {
    return {
      favDrawer: false,
      payDrawer: false,
      editDrawer: false,
      dialog: true,
      expensesForm: false,
      numberRules: [
        (v) => (/[0-9]|\./).test(v) || this.$language.validations['Only numbers allowed'],
        (v) => (v && v >= 0 && v <= 1000000) || this.$language.validations['Invalid value']
      ],
      expensesReasonDialog: false,
      payment: {
        expenses: 0,
        tip: 0,
        hours: 0,
        compensation: 0
      },
      expenses: null,
      expensesSummary: '',
      buttonLoading: false,
      loading: false,
      snackbar: {
        show: false,
        message: '',
        status: 'success'
      },
      sub: null,
      job: {
        warnings: {
          All: {}
        },
        applicants: {},
        payments: {
          transactions: {}
        }
      },
      chips: {
        name: 'All',
        id: 'All',
        avatar: 'people'
      },
      rating: {
        comment: '',
        rating: null,
        ratingDate: new Date()
      },
      profileDialog: false,
      applicantId: null,
      ratingProfileId: null,
      thisProfile: {},
      publishDialog: false,
      unpublishDialog: false,
      applyDialog: false,
      hireDialog: false,
      declineDialog: false,
      cancelDialog: false,
      deleteDialog: false,
      startDialog: false,
      completeDialog: false,
      payDialog: false,
      payProcessDialog: false,
      ratingDialog: false,
      inviteDialog: false,
      endContractDialog: false,
      selectAll: '',
      index: 1,
      index2: 1,
      index3: 4,
      menu: false,
      interval: null,
      secondsWorked: 0,
      paymentId: null,
      selectedShifts: [],
      selectedShiftsFixed: [],
      pendingShiftsFixed: [],
      pendingShifts: [],
      shiftPayAmount: 0,
      canPay: false,
      shiftDate: new Date().toISOString().slice(0, 10),
      nowDate: new Date().toISOString().slice(0, 10),
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1']
    }
  },

  mounted () {
    this.loading = true

    this.sub = object(fb.database.ref(`jobs/${this.$route.params.jobId}`))
      .pipe(map(change => ({
        _key: change.snapshot.key,
        ...change.snapshot.val()
      })))
      .subscribe(job => {
        this.job = job
        this.job._key = this.$route.params.jobId
        this.shiftPayAmount = this.job.public.compensation
        this.payment.compensation = this.job.public.compensation
        this.payment.hours = this.job.public.hours
        this.index += this.index
        this.$nextTick(() => {
          this.loading = false
        })
      })
  },
  destroyed () {
    clearInterval(this.interval)
    this.sub.unsubscribe()
  },
  computed: {
    ...mapState(['userProfile', 'currentUser', 'userJobs', 'openSettings']),

    tab: {
      set (tab) {
        this.$router.replace({ query: { ...this.$route.query, tab } })
        this.index += this.index
      },
      get () {
        return this.$route.query.tab
      }
    },

    filterWorkers () {
      return Object.values(this.job.applicants || {}).filter(item => {
        return item.status === 'Hired' || item.status === 'Started' || item.status === 'Completed' || item.status === 'Paid' || item.status === 'Pending Payment'
      })
    },
    isHefe () {
      return ((this.job || {}).public || {}).createdBy === this.currentUser.uid
    },

    approvedApplicants () {
      return Object.keys(this.job.applicants).filter((k) => {
        return this.job.applicants[k].status === 'Approved'
      })
    },
    invitedApplicants () {
      if ((this.job.applicants || {})[this.currentUser.uid]) {
        return this.job.applicants[this.currentUser.uid].status === 'Invited' ? 1 : 0
      }
      return false
    },
    hasStarted () {
      /* eslint-disable */
      var has = []
      Object.keys(((this.job || {}).applicants || {})).map(k => {
        (this.job.applicants[k].status === 'Started' || this.job.applicants[k].status === 'Completed' || this.job.applicants[k].status === 'Pending Payment' || this.job.applicants[k].status === 'Paid') ? has.push(true): 0
      })
      return has.length > 0 ? 1 : 0
      /* eslint-enable */
    },

    hasPendingShifts () {
      var shifts = Object.keys(((this.job || {}).applicants || {}))
        .map(k => {
          return Object.values(((((this.job || {}).applicants || {})[k] || {}).jobLog) || {}).map(j => {
            return j.status === 'pending'
          })
        })
      shifts = shifts.flat()
      shifts = shifts.includes(true)
      return shifts
    },
    hasRating () {
      return (((this.job || {}).applicants || {})[this.applicantId] || {}).obrRated || false
    }
  },

  methods: {
    selectShift (item) {
      if (this.selectedShifts) {
        this.selectedShifts.map(k => {
          if (k._key === item._key) {
            k.include = item.include
          }
          return k
        })
      } else {
        this.selectedShiftsFixed.map(k => {
          if (k._key === item._key) {
            k.include = item.include
          }
          return k
        })
      }

      this.$nextTick(() => {
        this.calcTotals()
      })
    },
    endContract () {
      var updates = {}
      var updatedDate = new Date()
      fb.geoFireApp.set(this.job._key, null)
      // if (this.hasPendingShifts) {
      //   updates[`jobs/${this.job._key}/public/status`] = 'Pending Payment'
      //   updates[`/user/${this.currentUser.uid}/jobs/${this.job._key}/status`] = 'Pending Payment'
      // } else {
      //   updates[`jobs/${this.job._key}/public/status`] = 'Completed'
      // }
      Object.keys(this.job.applicants).map((k) => {
        if (this.job.applicants[k].status === 'Started' || this.job.applicants[k].status === 'Hired') {
          updates[`/jobs/${this.job._key}/applicants/${k}/status`] = 'Completed'
          updates[`/user/${k}/jobs/${this.job._key}/status`] = 'Completed'
          updates[`/user/${k}/jobs/${this.job._key}/updatedDate`] = updatedDate
        }
      })
      updates[`/user/${this.currentUser.uid}/jobs/${this.job._key}/status`] = 'Completed'
      updates[`jobs/${this.job._key}/public/status`] = 'Completed'

      updates[`/user/${this.currentUser.uid}/jobs/${this.job._key}/updatedDate`] = updatedDate
      fb.database.ref().update(updates)
      this.endContractDialog = false
    },
    isRateTypeSelected (option) {
      let original = ['Hourly', 'Fixed']
      return original.indexOf(option) === this.$language.addJob['rateType'].indexOf(((this.job || {}).public || {}).rateType)
    },
    async openProfileDialog (data) {
      // fb.database.ref(`user/${data.profileId}/profile/public`).once('value').then(function (snapshot) {
      //   var job = snapshot.val()
      // })
      this.profileDialog = true
      this.$nextTick(() => {
        this.thisProfile = data
      })
    },
    closeDialog () {
      clearInterval(this.interval)
      this.interval = null
      this.$emit('simple-close')
      this.messageGroup = 'All'
      this.expensesSummary = ''
      this.expenses = 0
      this.cancelExpenseForm()
      if (this.sub !== null) {
        this.sub.unsubscribe()
        this.sub2.unsubscribe()
        this.warnSub.unsubscribe()
      }
      this.secondsWorked = 0
    },
    async publishJob () {
      this.buttonLoading = true
      if (this.job.public.public) {
        this.job.public.status = 'Published-Public'
        fb.geoFireApp.set(this.job._key, this.job.public.location)
      } else {
        this.job.public.status = 'Published-Private'
      }
      this.job.public.updatedDate = new Date()
      var updates = {}
      updates[`jobs/${this.job._key}`] = this.job
      updates[`user/${this.job.public.createdBy}/jobs/${this.job._key}/status`] = this.job.public.status
      updates[`user/${this.job.public.createdBy}/jobs/${this.job._key}/updatedDate`] = this.job.public.updatedDate
      await fb.database.ref().update(updates)
      this.publishDialog = false
      this.buttonLoading = false
      this.$emit('close', {
        window: 'job-details',
        show: true,
        message: this.$language.jobDetails['The job was published successfully']
      })
    },
    unpublishJob () {
      var updates = {}
      updates[`/geofire/${this.job._key}/`] = null
      updates[`/jobs/${this.job._key}/public/status`] = 'Draft'
      updates[`/user/${this.currentUser.uid}/jobs/${this.job._key}/status`] = 'Draft'
      this.unpublishDialog = false
      fb.database.ref().update(updates)
      this.publishDialog = false
      this.buttonLoading = false
      this.$emit('close', {
        window: 'job-details',
        show: true,
        message: this.$language.jobDetails['The job was published successfully']
      })
    },
    async cancelJob () {
      this.buttonLoading = true
      fb.geoFireApp.set(this.job._key, null)
      var updates = {}
      var updatedDate = new Date()
      updates[`jobs/${this.job._key}/public/status`] = 'Cancelled'
      updates[`/user/${this.currentUser.uid}/jobs/${this.job._key}/status`] = 'Cancelled'
      updates[`/user/${this.currentUser.uid}/jobs/${this.job._key}/updatedDate`] = updatedDate
      updates[`jobs/${this.job._key}/public/updatedDate`] = updatedDate

      var newKey = fb.database.ref().child(`jobs`).push().key
      var notification = {
        'notificationType': 'Cancelled',
        'notificationText': 'A job you submitted an application for was closed.',
        'notificationDate': updatedDate,
        'jobId': this.job._key,
        'defaultTab': ''
      }

      if (this.job.applicants) {
        Object.keys(this.job.applicants).map((k) => {
          if (this.job.applicants[k].status === 'Invited') {
            updates[`/user/${k}/profile/jobInvites/${this.job._key}`] = null
          } else {
            updates[`/user/${k}/jobs/${this.job._key}/status`] = 'Cancelled'
            updates[`/user/${k}/jobs/${this.job._key}/updatedDate`] = updatedDate
            updates[`/user/${k}/profile/notifications/${newKey}`] = notification
          }
        })
      }
      await fb.database.ref().update(updates)

      this.cancelDialog = false
      this.buttonLoading = false
      this.$emit('close', {
        window: 'job-details',
        show: true,
        message: this.$language.jobDetails['The job was cancelled successfully.']
      })
    },
    async deleteJob () {
      this.buttonLoading = true
      fb.geoFireApp.set(this.job._key, null)
      var updates = {}
      var updatedDate = new Date()
      updates[`jobs/${this.job._key}/public/status`] = 'Deleted'
      updates[`/user/${this.currentUser.uid}/jobs/${this.job._key}`] = null
      updates[`/user/${this.currentUser.uid}/deletedJobs/${this.job._key}/deletedDate`] = updatedDate
      updates[`jobs/${this.job._key}/public/updatedDate`] = updatedDate

      if (this.job.applicants) {
        Object.keys(this.job.applicants).map((k) => {
          updates[`/user/${k}/jobs/${this.job._key}`] = null
        })
      }
      await fb.database.ref().update(updates)

      this.deleteDialog = false
      this.buttonLoading = false
      this.$emit('close', {
        window: 'job-details',
        show: true,
        message: this.$language.jobDetails['The job was deleted successfully.']
      })
    },

    handlePayIndividual (profile) {
      this.applicantId = profile.profileId
      this.canPay = false
      if (this.job.public.rateType === 'Fixed') {
        this.pendingShiftsFixed = Object.values(profile.jobLog).map(k => {
          return k
        }).filter(k =>
          k.status === 'pending'
        )
        this.selectedShiftsFixed = this.pendingShiftsFixed
      } else {
        this.pendingShifts = Object.values(profile.jobLog).map(k => {
          return k
        }).filter(k =>
          k.status === 'pending'
        )
        this.selectedShifts = this.pendingShifts
      }
      this.$nextTick(() => {
        this.calcTotals()
      })
      this.payDrawer = true
    },
    async payIndividual () {
      this.buttonLoading = true
      this.payProcessDialog = true
      var updates = {}
      var newPayKey = fb.database.ref().child(`/jobs/${this.job._key}/payments/transactions`).push().key
      var updatedDate = new Date()

      // var notification = {
      //   'notificationType': 'Payment',
      //   'notificationText': `${this.userProfile.public.name} has initiated a payment for: ${this.job.title}`,
      //   'notificationDate': updatedDate,
      //   'jobId': this.job._key,
      //   'defaultTab': 'Status'
      // }

      var payment = {
        'senderStripeId': this.job.payments.senderStripeId,
        'jobId': this.job.public._key,
        'jobTitle': this.job.public.title,
        'recipientName': this.job.applicants[this.applicantId].name,
        'senderName': this.userProfile.public.name,
        'recipientStripeId': this.job.applicants[this.applicantId].stripeId,
        'mlm': this.job.applicants[this.applicantId].mlm,
        'paymentAmount': parseFloat(this.isRateTypeSelected('Fixed') ? ((parseFloat(this.payment.compensation) + parseFloat(this.payment.expenses) + parseFloat(this.payment.tip)) * 1.05) : (parseFloat(this.payment.compensation) +
            parseFloat(this.payment.expenses) + parseFloat(this.payment.tip)) * 1.05).toFixed(2),
        'paymentDate': updatedDate,
        'inProcess': true,
        'profileId': this.applicantId,
        'senderId': this.currentUser.uid,
        'mlmReferral': this.job.mlmReferral ? this.job.mlmReferral : null,
        'shiftPay': this.job.public.repeat,
        'hefeRated': this.job.applicants[this.applicantId].hefeRated || false
      }
      if (this.selectedShifts.length > 0) {
        payment.shifts = this.selectedShifts.filter(k => k.include)
        updates[`/jobs/${this.job._key}/applicants/${this.applicantId}/status`] = 'Started'
      }
      if (this.selectedShiftsFixed.length > 0) {
        payment.shifts = this.selectedShiftsFixed.filter(k => k.include)
        updates[`/jobs/${this.job._key}/applicants/${this.applicantId}/status`] = 'Started'
      }
      updates[`/jobs/${this.job._key}/payments/transactions/${newPayKey}`] = payment
      updates[`/jobs/${this.job._key}/applicants/${this.applicantId}/paymentRequested`] = false
      updates[`/user/${this.currentUser.uid}/customerPayments/transactions/${newPayKey}`] = payment
      fb.database.ref().update(updates)
      this.payment.compensation = this.shiftPayAmount
      this.selectedShifts = []
      this.index3 = this.index3 + 1
      this.payment.tip = 0
      this.buttonLoading = false
      this.ratingProfileId = this.applicantId
      this.paymentId = newPayKey
    },
    handleClosePayDialog () {
      this.payment.compensation = this.shiftPayAmount
      this.payment.tip = 0
      this.index3 = this.index3 + 1
      this.selectedShifts = []
      this.payDialog = false
    },
    handleRateIndividual (profile) {
      this.payDialog = false
      this.payProcessDialog = false
      this.ratingProfileId = this.applicantId ? this.applicantId : profile.profileId
      this.ratingDialog = true
    },
    async rate () {
      this.buttonLoading = true
      var updates = {}
      this.rating.ratedByName = this.userProfile.public.name
      this.rating.ratedById = this.currentUser.uid
      updates[`/jobs/${this.job._key}/applicants/${this.ratingProfileId}/obrRated`] = true
      updates[`/jobs/${this.job._key}/applicants/${this.ratingProfileId}/rating`] = this.rating.rating
      updates[`/user/${this.ratingProfileId}/profile/public/ratings/${this.job._key}`] = this.rating
      await fb.database.ref().update(updates)
      this.buttonLoading = false
      this.ratingDialog = false
      this.rating = {
        comment: '',
        rating: null,
        ratingDate: new Date()
      }
      this.snackbar.message = this.$language.jobDetails['Review submitted']
      this.snackbar.status = 'success'
      this.snackbar.show = true
    },
    favCheck (profile) {
      if (this.userProfile.favorites[profile.profileId] !== undefined) {
        return this.userProfile.favorites[profile.profileId]
      }
      return false
    },
    openSettingsDialog () {
      this.payProcessDialog = false
      this.$store.dispatch('openSettingsDialog', true)
    },
    setNewDefault (item) {
      item.date = new Date()
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/stripeCustomerAccount/setNewDefault`] = item
      updates[`user/${this.currentUser.uid}/profile/stripeCustomerAccount/processing`] = true
      fb.database.ref().update(updates)
    },
    deleteSource (item) {
      item.date = new Date()
      var updates = {}
      updates[`user/${this.currentUser.uid}/profile/stripeCustomerAccount/deleteSource`] = item
      updates[`user/${this.currentUser.uid}/profile/stripeCustomerAccount/processing`] = true
      fb.database.ref().update(updates)
    },
    rnd (a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    },
    calcTotals () {
      var expenseTotal = 0
      var include = null
      this.canPay = false
      if (this.selectedShifts.length > 0) {
        include = this.selectedShifts.filter(k => {
          return k.include
        })
        this.payment.hours = (include.reduce((acc, val) => {
          acc = parseInt(val.secondsWorked) + acc
          return acc
        }, 0) / 3600).toFixed(2)
      } else {
        include = this.selectedShiftsFixed.filter(k => {
          return k.include
        })
      }
      if (include.length > 0) {
        this.canPay = true
        include.map(l => {
          if (Object.keys(l.expenses || {}).length > 0) {
            Object.values(l.expenses)
              .map(j => {
                expenseTotal += parseFloat(j.amount)
              })
          }
        })

        this.payment.expenses = expenseTotal.toFixed(2)
        this.payment.compensation = this.isRateTypeSelected('Fixed') ? parseFloat(this.job.public.compensation * include.length).toFixed(2) : parseFloat(this.job.public.compensation * this.payment.hours).toFixed(2)
      } else {
        this.canPay = false
      }
    }
  },

  watch: {

    // 'payment.expenses': function (val) {
    //   if (val === '' || parseFloat(val) < 0) {
    //     this.payment.expenses = 0
    //   }
    // },
    'payment.tip': function (val) {
      if (val === '' || parseFloat(val) < 0) {
        this.payment.tip = 0
      }
    },
    'payment.hours': function (val) {
      this.payment.compensation = parseFloat(this.job.public.compensation * this.payment.hours).toFixed(2)
    },
    defaultTab () {
      this.tab = this.defaultTab
    },
    selectAll () {
      this.selectAllFavorites(this.selectAll)
    }
    // selectedShifts () {
    //   if (this.selectedShifts.length > 0) {
    //     this.payment.hours = (this.selectedShifts.reduce((acc, val) => {
    //       acc = parseInt(val.secondsWorked) + acc
    //       return acc
    //     }, 0) / 3600).toFixed(2)

    //     if (this.job.rateType === 'Fixed') {
    //       this.payment.compensation = this.selectedShifts.length * this.shiftPayAmount
    //       this.payment.expenses = this.selectedShifts.reduce((acc, val) => {
    //         acc = parseInt(val.expenses.amount) + acc
    //         return acc
    //       }, 0)
    //     }
    //   }
    // }
  },

  filters: {
    formatName (val) {
      var str = (val || 'N N').split(' ')
      if (str[1] !== undefined) {
        var name = str[0] + ' ' + str[1][0].toUpperCase() + '.'
      } else {
        name = str[0]
      }
      return name
    },
    formatDate (val) {
      if (!val) {
        return '-'
      }
      let date = val.toDate()
      return moment(date).fromNow()
    },

    formatDateTime (val) {
      if (!val) {
        return '-'
      }
      let date = new Date(val)
      return moment(date).fromNow()
    },
    formatTime (val) {
      return moment(val).format('hh:mm:ss a')
    },
    trimLength (val) {
      if (val.length < 200) {
        return val
      }
      return `${val.substring(0, 200)}...`
    },
    formatHours (val) {
      if (!val) {
        return '-'
      }
      return parseFloat(val / 60 / 60).toFixed(2)
    },
    formatHoursWorked (val) {
      if (!val) {
        return '-'
      }
      val = Math.floor(val / 3600)
      return Math.round(val % 24)
    },
    formatMinWorked (val) {
      if (!val) {
        return '-'
      }
      val = Math.floor(val / 60)
      var str = (Array(1).join('0') + 0).slice(-1) + Math.round(val % 60)
      val = Math.round(val % 60) < 10 ? str : Math.round(val % 60)
      return val
    },
    formatSecWorked (val) {
      if (!val) {
        return '-'
      }
      var str = (Array(1).join('0') + 0).slice(-1) + Math.round(val % 60)
      val = Math.round(val % 60) < 10 ? str : Math.round(val % 60)
      return val
    }
  }
}
</script>
<style>
.chat-container {
  height: calc(100vh - 13em);
  box-sizing: border-box;
  overflow-y: auto;
  background-color: #f2f2f2;
}

.custom-toolbar.v-toolbar__content,
.v-toolbar__extension {
  padding: 0px !important;
}

.centered-input input {
  text-align: end;
}

.blur-content {
  filter: blur(5px);
}
</style>
